export default {
  blue: '#4ea3d8',
  darkGrey: '#303030'
};



// WEBPACK FOOTER //
// ./src/themes/colors.js